export default {
  marketplace: {
    sellers: {
      sellers: "Penjual",
      addSeller: "Tambah Penjual",
      searchBySeller: "Cari berdasarkan Nama Penjual",
      noDataFound: "Data Tidak Ditemukan",
      youHaveNotAddedAnySellerYet: "Anda belum menambahkan penjual.",
      pleaseAddTheSellersToStart: "Silakan tambahkan penjual untuk memulai",
      filter: {
        product: "Produk",
        category: "Kategori",
        countries: "Negara",
        noOfProducts: "Jumlah Produk",
        noOfOrders: "Jumlah Pesanan",
        sellerStatus: "Status Penjual",
        from: "Dari",
        to: "Ke",
        of: "Dari",
        selectProduct: "Pilih Produk",
      },
      tableHeaders: {
        name: "Nama",
        email: "Email",
        country: "Negara",
        noOfProducts: "Jumlah Produk",
        noOfOrders: "Jumlah Pesanan",
        status: "Status",
        cityTown: "Kota",
      },
      active: "Aktif",
      deactivated: "Nonaktif",
      activateDeactivate: "Aktifkan/Nonaktifkan",
      headerTitleActivate: "Aktifkan Akun",
      headerTitleDeactivate: "Nonaktifkan Akun",
      deactivateConfirmationText: "Apakah Anda yakin ingin menonaktifkan?",
      reasonLabel: "Alasan",
      predefinedRangeLabel: "Rentang yang Ditentukan dari Tanggal Saat Ini",
      rangeOneDay: "Satu Hari",
      rangeOneWeek: "Satu Minggu",
      rangeOneMonth: "Satu Bulan",
      rangeLifetime: "Seumur Hidup",
      rangeCustom: "Kustom",
      fromDateLabel: "Dari",
      toDateLabel: "Ke",
      activationDateLabel: "Tanggal Aktivasi:",
      deactivationReasonLabel: "Alasan Penonaktifan:",
      activateConfirmationText: "Apakah Anda yakin ingin mengaktifkan?",
      activateLabel: "Aktifkan",
      cancelButton: "BATALKAN",
      completeButton: "Selesai",
      deactivateButton: "Nonaktifkan Akun",
      deactivateSuccessMessage: "Akun berhasil dinonaktifkan",
      deactivateErrorMessage: "Kesalahan saat menonaktifkan akun",
      reactivateSuccessMessage: "Akun berhasil diaktifkan kembali",
      reactivateErrorMessage: "Kesalahan saat mengaktifkan kembali akun",
    },
    settings: {
      header: "Pengaturan Marketplace",
      addMoreLabel: "Tambah lagi",
      generalSettingHeader: "Pengaturan Umum",
      settingHeader: "Pengaturan Akun Penjual Saya",
      editSettingsBtn: "Edit Pengaturan",
      numberOfProductHeading: "Pengaturan Jumlah Produk",
      numberOfProduct: "Jumlah Produk",
      storeSettingHeading: "Pengaturan Toko Saya",
      bankAccountHeading: "Atur / Edit Rekening Bank",
      editBankAccountBtn: "Kelola Rekening Bank",
      paypalAccountHeading: "Atur / Edit Akun PayPal",
      editPaypalAccountBtn: "Kelola Akun PayPal",
      pickupLocationsHeading: "Atur / Edit Lokasi Pengambilan",
      editPickupLocationBtn: "Kelola Lokasi Pengambilan",
      phoneNumberLabel: "Nomor Telepon",
      defaultCurrencyLabel: "Mata Uang Default",
      businessHoursLabel: "Jam Operasional",
      notificationSettingsHeader: "Pengaturan Notifikasi",
      phoneNumberPlaceHolder: "Masukkan Nomor Telepon",
      emailPlaceHolder: "Masukkan Email",
      currencyPlaceHolder: "Pilih Mata Uang",
      timingLabel: "Waktu",
      selectTiming: "Pilih Waktu",
      bankAccounts: "Rekening Bank",
      phoneMobile: "Telepon (Mobile)",
      phoneHome: "Telepon (Rumah)",
      cityTown: "Kota",
      addBankAccountBtn: "Tambah Rekening Bank",
      addPaypalAccountBtn: "Tambah Akun PayPal",
      addPickupLocationBtn: "Tambah Lokasi Pengambilan",
      accountTitle: "Judul Akun",
      bankLabel: "Bank",
      typeHere: "Ketik di sini",
      paypalAccounts: "Akun PayPal",
      paypalAccount: "Akun PayPal",
      pickupLocations: "Lokasi Pengambilan",
      addThisAddress: "Tambahkan alamat ini",
      businessHours: "Jam Operasional",
      timezone: "Zona Waktu",
      selectTimezone: "Pilih Zona Waktu",
      businessDays: "Hari Kerja",
      searchLocation: "Cari Lokasi",
    },
    dashboard: {
  title: "Judul",
  marketplace: "Pasar",
  viewAll: "Lihat Semua",
  topChart: "Grafik Teratas",
  today: "Hari Ini",
  week: "Minggu",
  month: "Bulan",
  year: "Tahun",
  categories: "Kategori",
  sellers: "Penjual",
  products: "Produk",
  orders: "Pesanan",
  total: "Total",
  localtradevsexport: "Perdagangan Lokal vs. Ekspor",
  exportAsPdf: "Ekspor sebagai PDF",
  exportAsCsv: "Ekspor sebagai CSV",
  export: "Ekspor",
  selectProductCategory: "Pilih Kategori Produk",
  trade: "Perdagangan",
  main: "Utama",
  subcategories: "Subkategori",
  active: "Aktif",
  inactive: "Tidak Aktif",
  completed: "Selesai",
  settings: "Pengaturan"
}
  },
}
